import React, { useCallback, useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { get, size } from "lodash";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Stack,
  Divider,
  FormControlLabel,
  Checkbox,
  IconButton,
} from "@mui/material";
import { useSnackbar } from "notistack";
// import CustomPopover, { usePopover } from "../../components/custom-popover";
import { color } from "../../utils/constant";
import { useLabForm } from "../../data/talons/Lab/useLabForm";
import { useSelector } from "react-redux";
import { getLabData } from "../../data/selectors/Lab/labform.selector";
/*
 * Render Real - Estate Inquiry Form screen
 *
 *
 */

export default function LabForm(props) {
  const { enqueueSnackbar } = useSnackbar();
  const editItem = useSelector(getLabData);
  const {
    loader,
    loading,
    status,
    labEntrySchema,
    handleStatusComboChange,
    labEntry,
    labUpdate,
  } = useLabForm({
    existingStatus: get(editItem, "status", 0),
  });

  const defaultValues = useMemo(() => ({
    test_name: get(editItem, "test_name", ""),
    price: String(get(editItem, "price", "")),
    details: get(editItem, "details", ""),
  }));
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    control,
  } = useForm({
    resolver: joiResolver(labEntrySchema),
    defaultValues,
  });

  const onlyNumbers = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, "");

    if (e.target.value.toString().length === 0) return;
    return (e.target.value = Math.max(0, parseInt(e.target.value))
      .toString()
      .slice(0, 10));
  };
  // //Validation UseEffect
  // useEffect(() => {
  //   if (errors?.reference_source) {
  //     enqueueSnackbar(errors.reference_source.message, {
  //       variant: 'error',
  //     });
  //     return;
  //   }
  // }, [errors]);

  const onUserSubmit = useCallback(async () => {
    try {
      const res =
        get(editItem, "id", null) === null
          ? await labEntry({
              ...getValues(),
            })
          : await labUpdate({
              ...getValues(),
              id: get(editItem, "id", null),
            });
      if (res === true) {
        props.postSubmit();
      } else {
        enqueueSnackbar("Problem While Saving Area Data", {
          variant: "error",
        });
      }
    } catch (err) {
      console.log("errr", err);
    }
  }, [labEntry, labUpdate]);

  const onlyCharacters = (e) => {
    e.target.value = e.target.value.replace(/[^a-zA-Z ]*$/, "");

    return e.target.value;
  };

  return (
    <React.Fragment>
      <Typography variant="h5" gutterBottom>
        Lab Test Form
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={2}>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="test_name"
            name="test_name"
            label="Lab Test"
            // onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
             // maxLength: 50,
            }}
            {...register("test_name")}
            autoComplete="false"
            error={size(errors?.test_name?.message) > 0 ? true : false}
            helperText={
              size(errors?.test_name?.message) > 0
                ? errors?.test_name?.message
                : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            required
            id="price"
            name="price"
            label="Price"
            fullWidth={true}
            variant="outlined"
            size="small"
            inputProps={{
              maxLength: 50,
            }}
            onInput={(e) => onlyNumbers(e)}
            {...register("price")}
            autoComplete="false"
            error={size(errors?.price?.message) > 0 ? true : false}
            helperText={
              size(errors?.price?.message) > 0 ? errors?.price?.message : ""
            }
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <TextField
            id="details"
            name="details"
            label="Details"
            // onInput={(e) => onlyCharacters(e)}
            fullWidth={true}
            variant="outlined"
            size="small"
            multiline
            minRows={2}
            inputProps={{
             // maxLength: 500,
            }}
            {...register("details")}
            autoComplete="false"
            error={size(errors?.details?.message) > 0 ? true : false}
            helperText={
              size(errors?.details?.message) > 0 ? errors?.details?.message : ""
            }
          />
        </Grid>

        <Grid item xs={3} sm={3}>
          <Typography>
            <FormControlLabel
              sx={{ mt: -1 }}
              control={
                <Checkbox
                  sx={{
                    "&.Mui-checked": {
                      color: color.button,
                    },
                  }}
                  id="is_labour"
                  checked={status}
                  onChange={handleStatusComboChange}
                />
              }
              label="Active"
            />
          </Typography>
        </Grid>
        <Grid container direction="row">
          <Grid item xs={12} sm={12}>
            <Stack direction="row" justifyContent="end">
              <Button
                variant="contained"
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  backgroundColor: color.button,
                  "&:hover": {
                    backgroundColor: color.button,
                  },
                }}
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleSubmit(onUserSubmit)();
                }}
              >
                Save
              </Button>
              <Button
                sx={{
                  height: 40,
                  borderRadius: 3,
                  m: 1,
                  borderColor: color.button,
                  color: color.button,
                  "&:hover": {
                    color: color.button,
                  },
                }}
                variant="outlined"
                onClick={(e) => {
                  e.preventDefault();
                  props.postSubmit();
                }}
              >
                Cancel
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}
